import React,{Component} from 'react';
import { connect } from 'react-redux';
import {withTranslation} from 'react-i18next';
import { withRouter } from 'react-router';
import * as actions from '../../../store/actions'
import Wrp from "../../../hoc/Wrp/Wrp";
import { callGET, callPOST, callPUT, callDELETE } from '../../../Utils/ApiUtil';
import * as ShipConstants from '../../../Global/Constants';
import BreadCrumbs from "../../../Components/UI/BreadCrumbs";
import {findFiltersOjectByFilterIdAndFilterArray, findFiltersByFieldIdWithFieldArr, prepareOptionArr, getValueFromOptions, isSet} from '../../../Utils/CommonFunctions';
import $ from 'jquery';
import LeftContent from './LeftContent';
import RightContent from './RightContent';
import Navbar from './Navbar';
import CreateNewVariable from './CreateNewVariable';
import AssignKeyword from './AssignKeyword';
import AutomationInputVariablesPopup from '../AutomationInputVariablesPopup';
import AutomationProgress from '../AutomationProgress';
import { v4 as uuidv4 } from 'uuid';

//Now hotcoded condition keywords , but need to fetch from db in future
export const conditionKeyWords = () => {
    return [
		{
			lable:"none",
			value:""
		},
        {
            label: "Run Keyword",
            value: "Run Keyword",
        },
        {
            label: "Run Keyword If",
            value: "Run Keyword If",
        },
        {
            label: "Run Keyword And Return",
            value: "Run Keyword And Return",
        },
        {
            label: "Run Keyword And Return Status",
            value: "Run Keyword And Return Status",
        },
        {
            label: "Run Keyword And Continue On Failure",
            value: "Run Keyword And Continue On Failure",
        },
        {
            label: "Run Keyword And Ignore Error",
            value: "Run Keyword And Ignore Error",
        },
    ];
}


class AutomationProcess extends Component {

	state = {
		processLine:[],
		newProcessLine:[],
		isNavbarOpen:false,
		currentTab:'variable',
		variableList:[],
		constantList:[],
		variableAndFieldList:[],
		variablesAndFields:[],
		triggerEffect : '',
		isCreateVariableModelOpen:false,
		editData:null,
		isRecordLoaded:false,
		goToLine:'',
		windowFields:null,
		windowFieldsBack:null,
		metaInfo:null,
		drillData:[],
		selectedWindow:'',
		relatedWindowFields:null,
		isKeywordEdit:false,
		assignKeywordModel:false,
		assignKeywordSeleced:'',
		expression_error:false,
		isArrayElementModalOpen:false,
    arrayElement:null,
    outputInnerFields:[],
		processLinesFields: {
			selectedKeyword : null,
			keyword_value_back:null,
			id:null,
			line_number:null,
			isExist:false,
			currentIndex:null,
			mappingFields : {
				inputField : '',
				operator : '',
				outputField : '',
				expression : '',
				outputFieldMapping:''
			},
			keyword : {
				name : "keyword",
				field : "select2",
				required : true,
				title : 'Window Type',
				placeHolder : "",
				value : '',
				classname : 'form-control',
				error: '',
				options : []
			},
			conditional_keyword : {
				name : "conditional_keyword",
				field : "select2",
				required : true,
				title : 'Conditional Keyword',
				placeHolder : "",
				value : '',
				classname : 'form-control',
				error: '',
				options : [...conditionKeyWords()]
			},
			pre_condition:{
				name : "pre_condition",
				field : "text",
				required : false,
				placeHolder : "",
				classname : 'w-100 no-bd form-control-sm form-control',
				value : '',
				error: '',
				options : []
			},
			keyword_value : {
					name : "keyword_value",
				field : "textarea",
				required : false,
				placeHolder : "",
				classname : 'w-100  fixedHeight',
				value : '',
				error: '',
				options : []
			},
			status : {
				name : "status",
				id:"status",
				field : "status",
				required : true,
				title : 'Status',
				placeHolder : "",
				value : '',
				classname : 'form-control',
				error: '',
				options : []
			},

		},
		addFormFields: {
			id:null,
			operation_name : {
						name : "operation_name",
	          field : "text",
	          required : true,
	          title : 'Operation Name',
	          placeHolder : "",
	          value : '',
	          classname : 'form-control',
	          error: '',
	          options : []
	        },
	        operation_type : {
	        	name : "operation_type",
	          field : "select2",
	          required : true,
	          title : 'Operation Type',
	          placeHolder : "",
	          value : '',
	          classname : 'form-control',
	          error: '',
	        },
	        window_type : {
	        	name : "window_type",
	          field : "select2",
	          required : true,
	          title : 'Window Type',
	          placeHolder : "",
	          value : '',
	          classname : 'form-control',
	          error: '',
	          options : []
	        },
	        description : {
	        	name : "description",
	          field : "textarea",
	          required : true,
	          title : 'Description',
	          placeHolder : "",
	          value : '',
	          classname : 'form-control',
	          error: '',
	          options : []
	        },
	        filters : [{
                tableDescriptorId: "",
                fieldFilterId: "",
                fieldFilter: [],
                values: [],
                lineNumber: 1,
                logicalOperator: "0",
                filterObject: null,
                fieldType: '',
                fieldTypeId : '',
                multiSelectOptions : [],
                lookupWindowName : '',
                lookupWindowNameId : '',
                absolute_window : '',
                absolute_window1: ''
            }]     
		},
		tableRecords:{
			pagination:{
        page:0,
        orderBy:'created_at',
        perPage:100,
        direction:'ASC',
        totalRecords:0,
        search:'',
        listId : {
          value : ''
        }
      }
		},
		isHiddenCardBoxShow:false,
		resourceData:{},
		executeResultModel:false,
    executeResult:[],
    isInputPopupModalOpen:false,
    variable_mappings:[],
    isAutomationProgressModelOpen:false,
    executeResults : {
      processId:'',
      statusCode:0,
      results:[],
      message:""
    },
	}

	componentWillMount = () => {
		const params = this.props.match.params;
		this.getAutomation(params.automationId);
		this.getKeywords();
		this.variableAndFieldList();
		this.variableList(params.automationId);
		this.getAutomationProcessLines(this.state.tableRecords.pagination);
		this.fetchFormulaFieldMetaInfo();
	}

	drillDownNextLevel=(parentData,isOutputFields=false) => {
      const updateState = {...this.state};
      const prntData = JSON.parse(parentData);
      /*if(updateState['drillData']) {
        updateState['drillData'].push(prntData);
      }else {
        updateState['drillData'] = [];
        updateState['drillData'].push(prntData);
      }
      updateState['windowFields'] = prntData.dependent_layout;*/
      if(isOutputFields) {
      	updateState['outputInnerFields'] = prntData.fields;
      	if(updateState['drillData']) {
	        updateState['drillData'].push(prntData);
	      }else {
	        updateState['drillData'] = [];
	        updateState['drillData'].push(prntData);
	      }
      }else {
      	updateState['windowFields'] = prntData.fields;
      	updateState['selectedWindow'] = prntData.field_name;
      }
      
      this.setState(updateState);
  }

  goBackDrillDown = (itemInd,isOutputFields=false) => {
    const updateState = {...this.state};
    if(isOutputFields) {
			let existData = updateState['drillData'];
	    const slicedArray = existData.slice(0, itemInd+1);
	    console.log(slicedArray);
	    if(itemInd !== -1) {
	      updateState['drillData'] = slicedArray;
	      if(slicedArray.length > 0) {
	          updateState['outputInnerFields'] = slicedArray[slicedArray.length-1].fields;  
	      }else {
	          updateState['outputInnerFields'] = [];
	      }
	    }else {
	      updateState['drillData'] = [];
	      updateState['outputInnerFields'] = [];
	    }
    }else {
    	updateState['windowFields'] = updateState['windowFieldsBack'];
    	updateState['selectedWindow'] = '';	
    }
    
    /*let existData = updateState['drillData'];
    const slicedArray = existData.slice(0, itemInd+1);
    if(itemInd !== -1) {
      updateState['drillData'] = slicedArray;
      if(slicedArray.length > 0) {
          updateState['windowFields'] = slicedArray[slicedArray.length-1].dependent_layout;  
      }else {
          updateState['windowFields'] = updateState['windowFieldsBack'];
      }
    }else {
      updateState['drillData'] = [];
      updateState['windowFields'] = updateState['windowFieldsBack'];
    }*/
    this.setState(updateState);
  }

	fetchFormulaFieldMetaInfo = () => {
    callGET("layouts/formulafield-metainfo")
    .then(response => {
      const responseData = response.data;
      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
         const metaInfo = responseData.data;
        this.setState({metaInfo:metaInfo})
      }
    }, (error) => {
      this.props.failMessage("Something went wrong..");
    })
  }

	saveProcessLinesHandler = (executeResult=false) => {
		const {Loader,succMessage,failMessage} = this.props;
		const {newProcessLine,tableRecords} = this.state;
		let totalSavedRecords = tableRecords.pagination.totalRecords;
		let lines = [];
		if(newProcessLine && newProcessLine.length>0) {
			newProcessLine.map((item,ind) => {
				item.line_number = item.line_number && item.line_number !== '' ? item.line_number : totalSavedRecords+(ind+1);
				lines.push(item);
			})
		}else {
				if(executeResult===true){
           this.setState({
             //isAutomationProgressModelOpen:(this.state.variableList.length===0)?true:false,
             isInputPopupModalOpen:(this.state.variableList.length>0)?true:true
           })
         }
			return false;
		}
		Loader();
		callPOST("automations-process/process-lines/create",lines)
    .then(response => {
     
      const responseData = response.data;
      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {

      	if(executeResult===true){
           this.setState({
             //isAutomationProgressModelOpen:(this.state.variableList.length===0)?true:false,
             isInputPopupModalOpen:(this.state.variableList.length>0)?true:true
           })
         }

        succMessage(responseData.message);
        this.setState({newProcessLine:[],isRecordLoaded:false,tableRecords:{
									pagination:{
						        page:0,
						        orderBy:'created_at',
						        perPage:100,
						        direction:'ASC',
						        totalRecords:0,
						        search:'',
						        listId : {
						          value : ''
						        }
						      }
								}});
        setTimeout(() => {
          this.getAutomationProcessLines(this.state.tableRecords.pagination);
        }, 200);
        
      }else {
    		failMessage(responseData.message/*+"<br/>"+errMsg*/);
    	}
    	 Loader(false);
  	})
    .catch(err => {
      Loader(false);
      failMessage("Error occured");
      console.log(err);
    })
	}

	keywordValueToggle = () => {
		this.setState({isKeywordEdit:!this.state.isKeywordEdit});
	}

	/*keywordValueChangeHAndler = (e) => {
		const {name,value} = e.target;
		const updateState = {...this.state};
		updateState['processLinesFields']['keyword_value_back'][name]=value;
		this.setState(updateState);
	}*/

	keywordValueChangeHAndler = (e) => {
		const {name,value} = e.target;
		const updateState = {...this.state};
		updateState['processLinesFields']['keyword_value']['value'][name]=value;
		this.setState(updateState);
	}

	updateKeywordValue = () => {
		const updateState = {...this.state};
		updateState.isKeywordEdit=false;
		updateState['processLinesFields']['keyword_value']['value']=JSON.stringify(updateState['processLinesFields']['keyword_value_back']);
		this.setState(updateState);
	}

	cardHiddenBoxHandler = () => {
    this.setState({isHiddenCardBoxShow:!this.state.isHiddenCardBoxShow})
  }
 

  updateInputValuesPayloadAction = (payload) => {
  		//console.log('updateInputValuesPayloadAction==',payload)
  		this.setState({variable_mappings:payload})
  }

  toggleProgressModel = () => {
  	this.setState({
    	isAutomationProgressModelOpen:!this.state.isAutomationProgressModelOpen,
      executeResults : {
        processId:'',
        statusCode:0,
        results:[],
        message:""
      }
    })
  	//this.setState({executeResultModel:!this.state.executeResultModel})
  }

  excecuteHandler = () => {
  	const params = this.props.match.params;	
  	let automationId = params.automationId;	    
		//console.log('processIData',processIData);
    // console.log(uuidv4()); return false;
		this.props.Loader();
		const msg = [{
        			    "Step1" :   "OPEN BROWSER :  Execute Successfully",
        			    "Step2" :   "${Carrier.username} = jiit@123  =>  Input Password : Executed Successfully",
        			    "Step3" :   "Password Text Box Not Identified",
        				 },{
							    "Step11" :   "OPEN BROWSER 1:  Execute Successfully",
							    "Step22" :   "${Carrier.username} = jiit@123  =>  Input Password : Executed Successfully",
							    "Step33" :   "Password Text Box Not Identified",
								 }];
    this.setState({
    	isAutomationProgressModelOpen:true,
    	// progressMsg:msg,
      executeResults : {
        processId:'',
        statusCode:0,
        results:[],
        message:""
      }
    })
    const uuid1 = uuidv4();
		const body = {
      automation_id:automationId,
      transaction_id:uuid1,
      variable_mappings:this.state.variable_mappings
    }
		callPOST("automations-process/execute",body)
      .then(response => {
      	const responseData = response.data;
        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
          this.getExecuteResults(automationId,uuid1);
          this.setState({
            isAutomationProgressModelOpen:true,
            // progressMsg:msg
          })
        }
        this.props.Loader(false);
      })
      .catch(err => {
        this.props.Loader(false);
        console.log("error occured",err);
      });
	}

	getExecuteResults = (processID,uuid="") => {
		let URL = "automations-process/result/"+processID+"/"+uuid;
		callGET(URL)
      .then(response => {
        const responseData = response.data;
        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
          const updateState = {...this.state}
          updateState.executeResults.statusCode = responseData.data.status_code;
          updateState.executeResults.message = responseData.data.message;
          updateState.executeResults.results = responseData.data.results;
          updateState.executeResults.processId = processID;
          this.setState(updateState);
        }
      })
      .catch(err => {
        console.log("error occured",err);
      });
	}

	render() {
		const breadCrumbs=this.getAndSetBreadCrumbs();
		const {isInputPopupModalOpen,variable_mappings,executeResultModel,isAutomationProgressModelOpen} = this.state;
		//console.log('variable_mappings==',variable_mappings)
		return (
			<Wrp>
        <BreadCrumbs breadCrumbsList={breadCrumbs} />
        <div className="viewport">
			   <div className="view view-xl">
					 
					 
					  <div className="view view-xl">
					   	<div className="portTwoSection">
							<Navbar
								{...this.state}
								{...this.props}
								toggleNavbar={this.toggleNavbar}
								changeTab={this.changeTab}
								toggleCreateVaiableModel={this.toggleCreateVaiableModel}
								editCreateVaiableModel={this.editCreateVaiableModel}
								deleteVaraibleHandler={this.deleteVaraibleHandler}
								cardHiddenBoxHandler={this.cardHiddenBoxHandler}
								editVariableHandler={this.editVariableHandler}
							/>
							<div className="view view-xl">
								<div className="outerPort" style={{top:"5px", left:"0px"}}>
									<div className="table_Box dataTables_wrapper">
										{/*automation details*/}
										<div className="table_Body  p-0">
											<div className="view view-xl">
												<div className="d-flex" style={{"bottom": "0px", "position": "absolute", "top": "0px", "width": "100%"}}>
													<LeftContent
														{...this.state}
														{...this.props}
														valueChangeHandler={this.valueChangeHandler}
														addLineHandler={this.addLineHandler}
														drillDownNextLevel={this.drillDownNextLevel}
														goBackDrillDown={this.goBackDrillDown}
														expressionChangeHandler={this.expressionChangeHandler}
														keywordValueToggle={this.keywordValueToggle}
														keywordValueChangeHAndler={this.keywordValueChangeHAndler}
														updateKeywordValue={this.updateKeywordValue}
														clearLineHandler={this.clearLineHandler}
														assignToKeywordToggleModel={this.assignToKeywordToggleModel}
													/>
													<RightContent
														{...this.state}
														{...this.props}
														getAutomationProcessLines={this.getAutomationProcessLines}
														goToLineChangeHandler={this.goToLineChangeHandler}
														goToProcessLine={this.goToProcessLine}
														editLineHandler={this.editLineHandler}
														deleteLineHandler={this.deleteLineHandler}
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
					   	</div>
					  </div>
					  
					 
			   </div>


			   {(isInputPopupModalOpen===true)?
            <AutomationInputVariablesPopup
            	{...this.state}
              // payloadData={{id:params.formId}}
              variablesList={this.state.variableList}
              executeResultToogle={this.executeResultToogle}
              toggleModel={this.toogleInputVariablePopup} 
              inputValuesPayload={this.state.variable_mappings}
              updateInputValuesPayloadAction={this.updateInputValuesPayloadAction}
            />
         :<></>}


         {
         	isAutomationProgressModelOpen === true?
         	<AutomationProgress
          	{...this.props}
            {...this.state}
            toggleModel={this.toggleProgressModel}
          />
         	:
         	<></>
         }

			  </div>

			  {
			  	this.state.isCreateVariableModelOpen === true?
			  	<CreateNewVariable
				  	{...this.state}
						{...this.props}
						toggleCreateVaiableModel={this.toggleCreateVaiableModel}
						saveVariableAndFields={this.saveVariableAndFields}
						toogleArrayElementModel={this.toogleArrayElementModel}
						variableFieldTypes={isSet(this.state.variablesAndFields.field_type,[])}
						formDetails={this.state.resourceData}						
				  />
			  	:
			  	<></>
			  }
			  
			  <AssignKeyword
			  	{...this.state}
					{...this.props}
					assignToKeywordToggleModel={this.assignToKeywordToggleModel}
					assignKeywordValueChangeHAndler={this.assignKeywordValueChangeHAndler}
					assignKeywordValueHandler={this.assignKeywordValueHandler}
			  />
      </Wrp>
		)
	}

	expressionChangeHandler = (name,value,isOnChange=false) => {
		const updateState = {...this.state};
		updateState['processLinesFields']['mappingFields'][name]=value;
		if(name === "expression" && isOnChange===true) {
			updateState['processLinesFields']['mappingFields']['inputField'] = '';
			updateState['processLinesFields']['mappingFields']['operator'] = '';
			updateState['processLinesFields']['mappingFields']['outputField'] = '';
			// updateState['processLinesFields']['mappingFields']['outputFieldMapping']='';
		}

		if(name === "expression"){
			updateState['expression_error'] = false;
		}
		this.setState(updateState);
	}

	goToLineChangeHandler = (e)=> {
		const {name,value} = e.target;
		const updateState = {...this.state};
		updateState[name]=value;
		this.setState(updateState);
		// this.setState({name:value});
	}

	goToProcessLine = () => {
		let page = parseInt(this.state.goToLine / 10, 10) * 10;
		if(page > 0) {
			page = page/10;
		}

		this.setState({isRecordLoaded:false,
      tableRecords:{
        ...this.state.tableRecords,
        pagination:{...this.state.tableRecords.pagination,page:page}
      }
    })
    setTimeout(() => {
      this.getAutomationProcessLines(this.state.tableRecords.pagination);
    }, 200);
	}

	getAutomationProcessLines = (pagination,isScroll=false) => {
		const params = this.props.match.params;
		const page = pagination.page; 
    const orderBy = pagination.orderBy; 
    const perPage = pagination.perPage; 
    const direction = pagination.direction; 
    const search = pagination.search;

    if(this.state.isRecordLoaded === true) {
    	return false;
    }

		const queryString = '?query='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction;
    callGET("automations-process/process-lines/"+params.automationId+"/list/"+queryString)
    .then(response => {
      const responseData = response.data;
      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
      	if(responseData.data && responseData.data.content) {
      		let cont = [];
      		let nextPage = 0;
      		let isRecordLoaded = false;
      		nextPage = parseInt(responseData.data.pageable.page_number) + parseInt(1);
  				if(isScroll === true) {
  					cont = this.state.processLine;
  					if(responseData.data.content && responseData.data.content.length > 0) {
  						responseData.data.content.map((item) => {
  							cont.push(item);
  						})
  					}else {
  						isRecordLoaded = true;
  					}
  				}else {
  					cont = responseData.data.content;
  				}
  				const totalRecords = responseData.data.total_elements;
  				this.setState({processLine:cont,isRecordLoaded:isRecordLoaded,
  					tableRecords:{
  						pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords,page:nextPage}
  					},
  				});
      		// this.setState({processLine:responseData.data.content});	
      	}else {
      		this.setState({isRecordLoaded:true});
      	}
      }
    }, (error) => {
      // this.props.failMessage("Something went wrong..");
    })
  }

	addLineHandler = () => {
		const params = this.props.match.params;
		const {processLinesFields,selectedKeyword,windowFieldsBack} = {...this.state};
		const {keyword,keyword_value,status,mappingFields,id,line_number,isExist,currentIndex,pre_condition,conditional_keyword} = {...processLinesFields};
		if(keyword.value ===''){
			return false;
		}

		
		const sel = {
			id:id,
			keyword_name:selectedKeyword.label,
			pre_condition:pre_condition.value,
			conditional_keyword:conditional_keyword.value,
			keyword_values:JSON.stringify(keyword_value.value),
			is_active:status.value,
			automation_id:params.automationId,
			output_variable:mappingFields.outputFieldMapping,
			constant:0,
			expression:mappingFields.expression,
			line_number:line_number,
			isExist:isExist,
			active:status.value
		}
		const updateState = {...this.state};
		updateState.processLinesFields.selectedKeyword=null;
		updateState.processLinesFields.id=null;
		updateState.processLinesFields.line_number=null;
		updateState.processLinesFields.isExist = false;
		updateState.processLinesFields.keyword.value = '';
		updateState.processLinesFields.keyword_value.value = '';
		updateState.processLinesFields.status.value = false;
		updateState.processLinesFields.currentIndex=null;
		updateState.processLinesFields.pre_condition.value="";
		updateState.processLinesFields.conditional_keyword.value="";
		updateState.processLinesFields.mappingFields = {
				inputField : '',
				operator : '',
				outputField : '',
				expression : '',
				outputFieldMapping:''
			};
		updateState.newProcessLine.push(sel);
		updateState.windowFields = windowFieldsBack;
		updateState.selectedWindow = '';

		if(id && id!== '') {
			updateState.processLine[currentIndex] = sel;
		}
		this.setState(updateState);
	}

	clearLineHandler = () => {
		const {processLinesFields,selectedKeyword,windowFieldsBack} = {...this.state};
		const updateState = {...this.state};
		updateState.processLinesFields.selectedKeyword=null;
		updateState.processLinesFields.id=null;
		updateState.processLinesFields.line_number=null;
		updateState.processLinesFields.isExist = false;
		updateState.processLinesFields.keyword.value = '';
		updateState.processLinesFields.keyword_value.value = '';
		updateState.processLinesFields.conditional_keyword.value="";
		updateState.processLinesFields.pre_condition.value="";
		updateState.processLinesFields.status.value = false;
		updateState.processLinesFields.currentIndex=null;
		updateState.processLinesFields.mappingFields = {
				inputField : '',
				operator : '',
				outputField : '',
				expression : '',
				outputFieldMapping:''
			};
		// updateState.newProcessLine = [];
		updateState.windowFields = windowFieldsBack;
		updateState.selectedWindow = '';

		this.setState(updateState);
	}

	editLineHandler = (data,ind) => {
		const params = this.props.match.params;
		const keywordVal = this.getOptionValueFromName(data.keyword_name);
		console.log("pre_condition"+data.pre_condition);
		console.log("conditional_keyword"+data.conditional_keyword);
		const updateState = {...this.state};
		updateState.selectedKeyword=keywordVal;
		updateState.processLinesFields.selectedKeyword=keywordVal;
		updateState.processLinesFields.id = data.id; 
		updateState.processLinesFields.keyword.value = keywordVal && keywordVal.value ? keywordVal.value : '';
		updateState.processLinesFields.keyword_value.value = JSON.parse(data.keyword_values);
		updateState.processLinesFields.status.value = data.active;
		updateState.processLinesFields.conditional_keyword.value=data.conditional_keyword;
		updateState.processLinesFields.pre_condition.value=data.pre_condition;
		updateState.processLinesFields.mappingFields.expression = data.expression;
		updateState.processLinesFields.line_number=data.line_number;
		updateState.processLinesFields.isExist=true;
		updateState.processLinesFields.currentIndex=ind;
		updateState.processLinesFields.mappingFields.outputFieldMapping = data.output_variable;
		// updateState.processLinesFields.mappingFields = {
		// 		inputField : '',
		// 		operator : '',
		// 		outputField : '',
		// 		expression : '',
		// 		outputFieldMapping:''
		// 	};
		// updateState.newProcessLine.push(sel);
		// updateState.windowFields = windowFieldsBack;
		// updateState.selectedWindow = '';
		// console.log(updateState.processLinesFields);
		this.setState(updateState);
	}

	deleteLineHandler = (lineID) => {
		console.log('deleteLineHandler==',lineID);
		const updateState = {...this.state};
		this.props.Loader();
    callDELETE("automations-process/process-line/"+lineID+"/delete")
    .then(response => {
      this.props.Loader();
      const responseData = response.data;
      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) { 
      	if(updateState.processLinesFields.id){
      		if(updateState.processLinesFields.id === lineID){
      			this.clearLineHandler();	
      		}
      	}

      	this.setState({tableRecords:{
								pagination:{
					        page:0,
					        orderBy:'created_at',
					        perPage:100,
					        direction:'ASC',
					        totalRecords:0,
					        search:'',
					        listId : {
					          value : ''
					        }
					      }
				}});
		    setTimeout(() => {
		      this.getAutomationProcessLines(this.state.tableRecords.pagination);
		    }, 500);        
        this.props.succMessage(responseData.message);
      }else {
        this.props.failMessage(responseData.message);
      }
      
    })	
	}

	getOptionValueFromName = (val) => {
		let returnVal = null;
		const options = this.state.processLinesFields.keyword.options;
		if(options) {
			options.map((item) => {
				if(item.name === val) {
					returnVal = item;
				}
			})
		}
		return returnVal;
	}

	toggleNavbar = () => {
		this.setState({isNavbarOpen:!this.state.isNavbarOpen});
	}

	changeTab = (val) => {
    this.setState({currentTab:val});
  }

	saveVariableAndFields = () => {
		const params = this.props.match.params;
		this.toggleCreateVaiableModel();
		this.variableList(params.automationId);
	}

	toggleCreateVaiableModel = () => {
		this.setState({isCreateVariableModelOpen:!this.state.isCreateVariableModelOpen})
	}

	editCreateVaiableModel = (data)=>{
    const {isCreateVariableModelOpen} = this.state;
    callGET("variable/"+data.id+"/search-fields")
    .then(response => {
      const responseData = response.data;
      const updateState = {...this.state}
      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
        const resData = data;
        resData['fields'] = responseData.data;
        this.setState({triggerEffect : Math.random(),editData : resData, isCreateVariableModelOpen:!isCreateVariableModelOpen});
      }
    }, (error) => {
      this.props.failMessage("Something went wrong..");
    })
    // this.setState({triggerEffect : Math.random(),editData : data, isCreateVariableModelOpen:!isCreateVariableModelOpen});
  }

  variableAndFieldList = () => {
    callGET("rates/field-type-list")
    .then(response => {
      const responseData = response.data;
      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
        this.setState({variablesAndFields:responseData.data});
      }
    }, (error) => {
      this.props.failMessage("Something went wrong..");
    })
  }

  variableList = (automationId) => {
    // callGET("variable/"+automationId+"/list/automation")
    // .then(response => {
    //   const responseData = response.data;
    //   const updateState = {...this.state}
    //   updateState['variableList'] = [];
    //   updateState['constantList'] = [];
    //   if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
    //     const data = responseData.data;
    //     if(data) {
    //       updateState['variableList'] = data.global_variables;
    //       updateState['constantList'] = data.global_constants; 
    //     }
    //   }
    //   this.setState(updateState);
    // }, (error) => {
    //   // this.props.failMessage("Something went wrong..");
    // })

    const queryStringNew = '?functionType=AUTOMATION&referenceId='+automationId;
    callGET("variable/search"+queryStringNew)
    .then(async (response) => {
      const responseData = response.data;
      if(responseData.code === 200) {
        const data = responseData.data;
        let global_constants = [];
        let global_variables = [];
        isSet(data,[]).map((item,index)=>{

          // if(isSet(item.window_id,null)!==null){
          //   // alert('item.window_id');)
          //   this.generateWindowFields(item.window_id);
          // }
          
          if(item.is_constant === true){
            global_constants.push(item);
          }else{
            global_variables.push(item);
          }
          // if(item.fieldtype_name==='Object' || item.fieldtype_name==='Array' || item.fieldtype_name==='Messages'){
          //   this.props.setArrayObjectVariablesAction(item.id,item.fields);
          // }
        })

        const updateState = {...this.state}
        updateState['variableList'] = global_variables;
        updateState['constantList'] = global_constants;
        this.setState(updateState);
        

      }
    },(error) => {
      console.log(error);
    }) 


  }

  deleteVaraibleHandler = (id) => {
    const params = this.props.match.params;
    // let isDelete = window.confirm("are you sure you want to delete this data?");
    // if(isDelete) {
      this.props.Loader();
      callDELETE("automations-process/variables/"+id+"/delete")
      .then(response => {
        this.props.Loader();
        const responseData = response.data;
        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) { 
          this.variableList(params.automationId);
          this.props.succMessage(responseData.message);
        }else {
          this.props.failMessage(responseData.message);
        }
        
      })
    // }
  }

  editVariableHandler = (data) => {
  	if(data.fieldtype_name === 'Array' || data.fieldtype_name === 'Object' || data.fieldtype_name === 'Messages') {
      callGET("variable/"+data.id+"/search-fields")
        .then(response => {
          const responseData = response.data;
          if(responseData.code === 200) {
            const resData = data;
            data['fields'] = responseData.data;
            this.setState({resourceData:data});
            // console.log('data',data);
            this.toggleCreateVaiableModel();
            // this.setState({triggerEffect : Math.random(),editData : resData, isCreateVariableModelOpen:!isCreateVariableModelOpen});
          }else {
            this.setState({resourceData:data});
            this.toggleCreateVaiableModel();
          }
        }, (error) => {
          this.props.failMessage("Something went wrong..");
          this.setState({resourceData:data});
          this.toggleCreateVaiableModel();
      })
    }else {
      this.setState({resourceData:data});
      this.toggleCreateVaiableModel();
    }
  }

	valueChangeHandler = (value,name) => {
		const updateState = {...this.state};
		if(name === 'keyword') {
			const selectedValue = getValueFromOptions(value,this.state.processLinesFields.keyword.options);
			if(selectedValue && selectedValue.data) {
				updateState.selectedKeyword=selectedValue;
				// updateState.processLinesFields['keyword_value_back'] = JSON.parse(selectedValue.data.keyword_values);
				updateState.processLinesFields['keyword_value'].value=JSON.parse(selectedValue.data.keyword_values);
			}
		}
		updateState.processLinesFields[name].value=value;
		this.setState(updateState);
	}

	getKeywords = () => {
		callGET('automations-process/keywords/search')
    	.then(response => {
    		const responseData = response.data;
    		if(responseData.code === ShipConstants.API_STATUS_SUCCESS) { 
    			if(responseData.data) {
    				let keywords = [{
			                "name": "",
			                "value": "",
			                "label": "",
			                "data": null
		              	}];
    				responseData.data.map(item => {
    					const value = {
			                "name": item.keyword_name,
			                "value": item.id,
			                "label": item.keyword_name,
			                "data":item
		              	}
		              	keywords.push(value);
    				})
    				const updateState = {...this.state};
			        updateState.processLinesFields.keyword.options = keywords;
			        this.setState(updateState);
    			}
    			
    		}
    	})
	}

	getAutomationold = (id) => {
		callGET('automations-process/'+id)
    	.then(response => {
    		const responseData = response.data;
    		if(responseData.code === ShipConstants.API_STATUS_SUCCESS) { 
    			const data = responseData.data;
    			callGET('field-groups/window/'+data.window_id+'/lookup-layouts')
		  		.then(windowResponse => {
						const windowFields = windowResponse.data.data;
						this.setState({windowFields:windowFields,windowFieldsBack:windowFields});
					})

		  	}

		  })
	}

	getAutomation = (id) => {
		callGET('automations-process/search-by-id/'+id)
    	.then(response => {
    		const responseData = response.data;
    		if(responseData.code === ShipConstants.API_STATUS_SUCCESS) { 
    			const data = responseData.data;
    			const body = {
				      window_info : {
				        window_id : data.window_id,
				        related_window : data.related_windows
				      }
				    }
				   // console.log(body)
	    		 callPOST("field-groups/window/related-windows/fields",body)
			      .then(response => {
			        const responseData = response.data;
			        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
			        	let fieldOptions = [];
			        	let relatedWindowFields = responseData.data;
						    if(relatedWindowFields && relatedWindowFields.window_fields) {
						    		
						    		let windowList = [];
								    if(relatedWindowFields && relatedWindowFields.window_fields) {
								        Object.keys(relatedWindowFields.window_fields).map(function(key) {
								            windowList.push(key);
								        })      
								    }

						        windowList.map((windArr,windInd) => {
						            let label = '';
						            let options = [];
						            label = windArr;
						            /*relatedWindowFields.window_fields[windArr].map((field,ind) => {
						                options.push({label: field.field_name, value: field.id,fieldtype:field.field_type})
						            })*/
						            fieldOptions.push({field_name:label,fields:relatedWindowFields.window_fields[windArr]})
						        })
						    }
			        	this.setState({windowFields:fieldOptions,windowFieldsBack:fieldOptions,relatedWindowFields:relatedWindowFields});
			        }
			      })
			      .catch(err => {
			        this.props.Loader(false);
			        console.log("error occured",err);
			      });

		  	}

		  })
	}

	getAutomationDetail = (id) => {
		callGET('automations-process/search-by-id/'+id)
    	.then(response => {
    		const responseData = response.data;
    		if(responseData.code === ShipConstants.API_STATUS_SUCCESS) { 
    			const data = responseData.data;
    			callGET('field-groups/window/'+data.window_id+'/lookup-layouts')
		  		.then(windowResponse => {
					const windowFields = windowResponse.data.data;
					
	    		const updateState = {...this.state};
	    		// updateState.windowFields = windowFields;  
					updateState.addFormFields.operation_name.value = data.name;
					updateState.addFormFields.operation_type.value = data.automation_type;
					updateState.addFormFields.window_type.value = data.window_id;
					updateState.addFormFields.description.value = data.description;
					updateState.addFormFields.id = data.id;
					if(data.filters) {
						const fieldFilter = windowFields.fields_with_filters && windowFields.fields_with_filters.window_fields ? windowFields.fields_with_filters.window_fields : [];
						const fieldWithFilters= windowFields.fields_with_filters;

						data.filters.forEach(function(filterData) {
							const filterDataVal = findFiltersByFieldIdWithFieldArr(filterData.tableDescriptorId, fieldFilter, fieldWithFilters);
							filterData.fieldFilter = filterDataVal.filters;
							const data1 = findFiltersOjectByFilterIdAndFilterArray(filterData.fieldFilterId, filterDataVal.filters);
							filterData.filterObject = data1;
							const multiSelectOptions = filterDataVal.options;
							filterData.multiSelectOptions = prepareOptionArr(multiSelectOptions);
							filterData.fieldType = filterData.field_type_name;
							let lookupField = [];
					        if(filterData.absolute_display && filterData.absolute_display !== '') {
					        	let res = filterData.absolute_display.split(".");
					        	if(res.length > 0) {
					                res.map((arr1,ind) => {
					                    lookupField.push({field_name :arr1});
					                })
					            }
					        }
					        lookupField.push({field_name :filterData.display_name});
					        filterData.absolute_window1 = lookupField;
					        if(filterData.values) {
					        	filterData.values.map((item,iind) => {
					        		item.text = item.label;
					        		item.id = item.value;
					        	})
					        }
					        filterData.lookupWindowName = filterData.lookup_window_name;
					        if(filterData.dependent_layout) {
								filterData.lookupWindowNameId = filterData.dependent_layout.window_id;
							}

					        if(filterData.fieldType && filterData.fieldType.toLowerCase() === 'notes') {
					            filterData.lookupWindowName = filterData.windowName;
					            filterData.lookupWindowNameId = filterData.windowId;
					            filterData.isNotes=true;
					        }

					        if(filterData.dependent_layout && filterData.dependent_layout.window_id === ShipConstants.NOTES_WINDOW_ID) {
					        		filterData.lookupWindowName = filterData.windowName;
					            filterData.lookupWindowNameId = filterData.windowId;
					            filterData.isNotes=true;
					        }

					        if(filterData.fieldType === 'User') {
					            filterData.lookupWindowName = "User";
					            filterData.lookupWindowNameId = ShipConstants.USERS_WINDOW_FIELD_ID;
					        }

						});
						updateState.addFormFields.filters = data.filters;
					}
					updateState.isCreateNewModelOpen = true;
					this.setState(updateState);
		  		})
    		}
    	})
	}

	getAndSetBreadCrumbs = () => {
		return {
	      backHistory : [{
                href : "/settings",
                name:"Settings"
              },{
                href : "/automation/automation-list",
                name:"Automations"
              }],
	      pageTitle:"Automation Process List",
	      buttonList:[{
            href:"/automation/automation-list",
            name:"Cancel",
            attributes:{
              className:"btn border-default btn-border mr-2"
            },
            type:"cancel",
            icon:"fas fa-plus smoky_light_color",
          },
          {
		        name:"Execute",
		        type:"save",
		        clickHandler:()=>this.executeResultToogleHandler(true),
		        attributes:{
		          className:"btn secondary_bg mr-2",
		        }
	      	},
	      	{
		        name:"Save",
		        type:"save",
		        clickHandler:this.saveProcessLinesHandler,
		        attributes:{
		          className:"btn primary_bg",
		        }
	      	}
	      ]
	    }
	}

	executeResultToogleHandler = async (isBool=false)=>{
		//console.log('executeResultToogleHandler==')
    if(isBool===true){
      this.saveProcessLinesHandler(true);
    }else{
      this.setState({
        executeResultModel:isBool,
      })
    }
  }
  executeResultToogle = ()=>{
    this.setState({
      //isAutomationProgressModelOpen:true,
      isInputPopupModalOpen:false
    })    
    this.excecuteHandler();
  }
  toogleInputVariablePopup = (bool=false)=>{
    this.setState({
      isInputPopupModalOpen:bool
    })
  }

	assignToKeywordToggleModel = () => {
		const updateState = {...this.state};
		if(updateState['processLinesFields']['mappingFields']['expression'] === "") {
			updateState['expression_error'] = true;
			this.setState(updateState);
			return false;
		}
		this.setState({assignKeywordModel:!this.state.assignKeywordModel,assignKeywordSeleced:''});
	}

	assignKeywordValueChangeHAndler = (keyword) => {
		this.setState({assignKeywordSeleced:keyword});
	}

	assignKeywordValueHandler = () => {
		const updateState = {...this.state};
		const {assignKeywordSeleced,processLinesFields} = updateState;
		const {expression} = processLinesFields.mappingFields;
		if(updateState.assignKeywordSeleced==="PRE CONDITIONS"){
			updateState['processLinesFields']["pre_condition"]["value"] = expression;
		}else{
			updateState['processLinesFields']['keyword_value']['value'][assignKeywordSeleced]=expression;
		}
		
		updateState['assignKeywordModel']=false;
		updateState['assignKeywordSeleced']='';
		updateState['processLinesFields']['mappingFields']['inputField'] = '';
		updateState['processLinesFields']['mappingFields']['operator'] = '';
		updateState['processLinesFields']['mappingFields']['outputField'] = '';
		updateState['processLinesFields']['mappingFields']['expression'] = '';
		this.setState(updateState);

		var elem = document.getElementById("keywordName");
    if(elem) {
        elem.scrollIntoView();    
    }
	}

	toogleArrayElementModel = (arrayData) => {
    this.setState({isArrayElementModalOpen:!this.state.isArrayElementModalOpen,arrayElement:arrayData});
  }

}

const mapDispatchToProps = dispatch => {
  return {
    Loader : (msg) => dispatch(actions.loader(msg)),
    succMessage : (msg) => dispatch(actions.succMessage(msg)),
    failMessage : (msg) => dispatch(actions.failMessage(msg))    
  };
}

export default connect(null, mapDispatchToProps)(withRouter(withTranslation()(AutomationProcess)));